/**
 * db.ts — Dexie (IndexedDB) 本機快取與離線 outbox
 */
import Dexie, { type EntityTable } from 'dexie'

// ─── 型別 ────────────────────────────────────────────────

export interface Expense {
  id: string                // uuid，前端產生
  date: string              // 'YYYY-MM-DD'
  category: string
  description: string | null
  amount: number
  odometer_km: number | null
  note: string | null
  fuel_grade: string | null
  liters: number | null
  is_full_tank: boolean | null
  reminder_rule_id: string | null
  created_at: string
  updated_at: string
  deleted_at: string | null
}

export interface OdometerReading {
  id: string
  date: string
  odometer_km: number
  note: string | null
  created_at: string
}

export interface ReminderRule {
  id: string
  name: string
  category: string | null
  interval_km: number | null
  interval_months: number | null
  warn_before_km: number
  warn_before_days: number
  last_done_date: string | null
  last_done_km: number | null
  enabled: boolean
}

export interface FuelPrice {
  effective_date: string
  grade: string
  price_per_liter: number
}

export interface Settings {
  id: string                // 固定為 'singleton'
  stats_start_month: string | null  // 'YYYY-MM-DD'
  default_fuel_grade: string
}

export interface Budget {
  id: string
  period: 'month' | 'year'
  amount: number
  exclude_car_price: boolean
}

// outbox 待上傳的操作
export interface OutboxItem {
  id?: number  // auto-increment
  table: string
  record_id: string
  operation: 'upsert' | 'delete'
  payload: string  // JSON
  created_at: string
}

// ─── Dexie DB ─────────────────────────────────────────────

class MotoExpenseDB extends Dexie {
  expenses!: EntityTable<Expense, 'id'>
  odometer_readings!: EntityTable<OdometerReading, 'id'>
  reminder_rules!: EntityTable<ReminderRule, 'id'>
  fuel_prices!: EntityTable<FuelPrice, 'effective_date'>
  settings!: EntityTable<Settings, 'id'>
  budgets!: EntityTable<Budget, 'id'>
  outbox!: EntityTable<OutboxItem, 'id'>

  constructor() {
    super('MotoExpenseDB')
    this.version(1).stores({
      expenses: 'id, date, category, updated_at, deleted_at',
      odometer_readings: 'id, date',
      reminder_rules: 'id, category, enabled',
      fuel_prices: '[effective_date+grade], effective_date',
      settings: 'id',
      budgets: 'id, period',
      outbox: '++id, table, record_id, created_at',
    })
  }
}

export const db = new MotoExpenseDB()
